import { QuestionSource } from "./question";
export class QuestionFilter {
    static filter(questions, regionKey, regionId) {
        return questions.filter((q) => {
            if (q.source === QuestionSource.Entity) {
                return !!q.regions.some(r => r === regionId);
            }
            else {
                if (!regionKey)
                    return true;
                if (!q.regionMask)
                    return true;
                if (q.regionMask.length === 0)
                    return true;
                return q.regionMask.indexOf(regionKey) >= 0;
            }
        });
    }
    static filterAll(questions, regions, regionIds) {
        return questions.filter((q) => {
            if (q.source === QuestionSource.Entity) {
                return !!q.regions.some(r => regionIds.includes(r));
            }
            else {
                if (!regions || regions.length === 0) {
                    return true;
                }
                if (!q.regionMask)
                    return true;
                if (q.regionMask.length === 0)
                    return true;
                return regions.some(region => q.regionMask.indexOf(region) >= 0);
            }
        });
    }
}
//# sourceMappingURL=question-filter.js.map